import React from "react";

import { Divider } from "@busbud/horizon";

import { FeesLines } from "@app/components/trip-fare-summary/fees-lines";
import { SubtotalLine } from "@app/components/trip-fare-summary/subtotal-line";
import { TaxesLines } from "@app/components/trip-fare-summary/taxes-lines";
import { useAppContext } from "@app/helpers/hooks";
import type { BookingCharges } from "@app/types/napi-charge-types";

import type { ConnectorProps } from "./fee-list.connect";

import { DiscountCode } from "../discount-code";
import { RedeemCredits } from "../redeem-credits/redeem-credits.connect";

export interface CartCharges {
  total: number;
  subtotal: number;
  taxes: number;
  fees: number;
  busbud_fee?: number;
  code_discount?: number | null;
}
interface FeeListProps extends ConnectorProps {
  is_discount_supported: boolean;
  initial_discount_code: string | null;
  operators_name: string[];
  charges?: CartCharges;
  source_names: string[];
}

export const FeeList: React.FC<FeeListProps> = props => {
  const { api } = useAppContext();
  const charges = props.charges || props.cart_charges;

  function _submitDiscountCode(discount_code: string) {
    return (
      props.actions.addDiscountCode({
        api,
        discount_code
      }) as any
    ).unwrap();
  }

  function _resetDiscountCode(discount_code: string) {
    return (
      props.actions.removeDiscountCode({
        api,
        discount_code
      }) as any
    ).unwrap();
  }

  const {
    currency,
    whitelabel,
    is_discount_supported,
    tax_breakdown,
    operators_name,
    cart_is_loading,
    source_names
  } = props;
  const { total, subtotal, fees, busbud_fee, taxes } = charges;
  const shared_props = { currency_code: currency.value, whitelabel };
  const code_discount = getDiscountAmount(charges);
  const display_subtotal = total !== subtotal;

  return (
    <div className="flex flex-col gap-200">
      <div className="flex flex-col gap-100">
        {!!display_subtotal && (
          <>
            <Divider className="mb-100" />
            <SubtotalLine amount={subtotal} {...shared_props} />
          </>
        )}
        <RedeemCredits variant="line" />
        {!!is_discount_supported && (
          <DiscountCode
            initial_discount_code={props.initial_discount_code}
            onSubmit={_submitDiscountCode}
            onReset={_resetDiscountCode}
            discount_amount={code_discount}
            discount_currency={currency.value}
            is_loading={cart_is_loading}
          />
        )}
      </div>
      {(!!fees || !!taxes) && (
        <>
          <Divider />
          <div className="flex flex-col gap-100">
            <FeesLines
              amount={fees}
              busbud_fee={busbud_fee}
              is_loading={false}
              // @ts-expect-error TS2322 Unsafe indexed access (noUncheckedIndexedAccess); tracked in #24591
              operator_name={operators_name[0]}
              source_names={source_names}
              {...shared_props}
            />
            <TaxesLines
              amount={taxes}
              breakdown={tax_breakdown}
              {...shared_props}
            />
          </div>
        </>
      )}
    </div>
  );
};

function getDiscountAmount(charges: BookingCharges | CartCharges) {
  return "code_discount" in charges ? charges.code_discount : null;
}
